// extracted by mini-css-extract-plugin
export default {"last":"Breadcrumbs_last__LD0al"};